import { fallbackLng, languages } from "@/lib/i18n/settings";

/** Derive short UI language code (sv|en|de|da) from a full shop-culture value. */
export function getShortLngFromCulture(culture: string | undefined | null): string {
  if (!culture) return fallbackLng;
  const short = culture.split("-")[0]?.toLowerCase();
  if (short && (languages as readonly string[]).includes(short)) {
    return short;
  }
  return fallbackLng;
}
